import { render, staticRenderFns } from "./NaoAutorizado.vue?vue&type=template&id=d125c106&scoped=true"
import script from "./NaoAutorizado.vue?vue&type=script&lang=js"
export * from "./NaoAutorizado.vue?vue&type=script&lang=js"
import style0 from "./NaoAutorizado.vue?vue&type=style&index=0&id=d125c106&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d125c106",
  null
  
)

export default component.exports